import {Paper} from '../ui'
import styleClasses from './classes@desktop.module.css'
import {Logo} from './logo'

export function TariffsHeader() {
  return (
    <Paper className={styleClasses.header}>
      <Logo />
    </Paper>
  )
}
